import BaseService from './base';
export interface CaliberViewModel {
  id?: number;
  themeID?: number;
  title?: string;
  content?: string;
  isPublic?: number;
  userID?: string;
  createTime?: Date;
  lastModifyTime?: Date;
}

export class CaliberService extends BaseService<CaliberViewModel> {
  protected serviceApi: string = 'Caliber';

  get NewModel(): CaliberViewModel {
    return {
      title: '',
      isPublic: 0,
    };
  }
}
